import { escapeHtml } from '@/lib/journal/journalRichText';

export function journalQuoteHtml(input: {
  text: string;
  attribution: string;
}): string {
  const text = input.text.trim();
  if (!text) return '';
  const body = escapeHtml(text).replace(/\n/g, '<br>');
  return `<blockquote><p><small>${escapeHtml(input.attribution)}</small></p><p>${body}</p></blockquote>`;
}

export function selectedTextInNode(root: HTMLElement | null): string {
  if (!root) return '';
  const selection = window.getSelection();
  if (!selection || selection.rangeCount === 0 || selection.isCollapsed) return '';
  const range = selection.getRangeAt(0);
  if (!root.contains(range.commonAncestorContainer)) return '';
  return selection.toString().replace(/\u00a0/g, ' ').trim();
}
